export const BOOK_APPOINTMENT_PATH = '/book-appointment';
export const ONLINE_BOOKING_PATH = `${BOOK_APPOINTMENT_PATH}#online-booking`;
export const SIGNATURE_BOOKING_PATH = `${BOOK_APPOINTMENT_PATH}#signature-consult`;
export const VIRTUAL_BOOKING_PATH = SIGNATURE_BOOKING_PATH;

export const CONSULTATIONS = [
  {
    id: 'signature',
    label: 'Signature Consult',
    location: 'In office',
    price: 300,
    description: 'A complete evaluation and a personalized treatment plan.',
    inclusions: [
      '90-minute consultation with Dr. Gjelaj',
      'Exam, CBCT, X-rays and an intraoral scan',
      'Written treatment plan with exact pricing',
      '$300 credited toward treatment begun within 30 days',
    ],
  },
];